import { Component } from "react";

import Link from "admin/shared/ui/Link.Component";

import Button from "@material-ui/core/Button";

export default class LoanstepActions extends Component {
  render() {
    let id = this.props.userId;

    return (
      <div className="user-panel-navigation">
        <Link
          className="user-panel-navigation-item"
          activeClassName={"selected"}
          toState={"userOverview"}
          onlyActiveOnIndex={true}
          parameters={["query", id]}
        >
          <Button variant="contained" color="primary">
            Overview
          </Button>
        </Link>
        <Link
          className="user-panel-navigation-item"
          activeClassName={"selected"}
          toState={"userApplications"}
          onlyActiveOnIndex={true}
          parameters={["query", id]}
        >
          <Button variant="contained" color="primary">
            Applications
          </Button>
        </Link>
        <Link
          className="user-panel-navigation-item"
          activeClassName={"selected"}
          toState={"userCreditApplications"}
          onlyActiveOnIndex={true}
          parameters={["query", id]}
        >
          <Button variant="contained" color="primary">
            Credit Applications
          </Button>
        </Link>
        <Link
          className="user-panel-navigation-item"
          activeClassName={"selected"}
          toState={"userLoans"}
          onlyActiveOnIndex={true}
          parameters={["query", id]}
        >
          <Button variant="contained" color="primary">
            Loans
          </Button>
        </Link>
        <Link
          toState={"userAMLProfile"}
          className="user-panel-navigation-item"
          activeClassName={"selected"}
          onlyActiveOnIndex={true}
          parameters={["query", id]}
        >
          <Button variant="contained" color="primary">
            Borrower Aml Profile{" "}
          </Button>
        </Link>
      </div>
    );
  }
}
